class movieDB {
	_url = 'https://api.themoviedb.org/3';
	_apiKey = `?api_key=${process.env.REACT_APP_MOVIE_API_KEY}`;

	async getMovies(url, params) {
		let result;
		result = await fetch(`${url}${this._apiKey}&language=en_US${params ? params : null}`);
		return await result.json();
	}

	async createGuestSession() {
		let result;
		result = await fetch(`${this._url}/authentication/guest_session/new${this._apiKey}`, { method: 'GET' });
		return await result.json();
	}

	async rateMovie(movieId, guestId, rateValue) {
		const options = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: `{"value":${rateValue}}`,
		};
		const result = await fetch(`${this._url}/movie/${movieId}/rating${this._apiKey}&guest_session_id=${guestId}`, options);
		return await result.json();
	}

	getPopularMovies(page = 1) {
		return this.getMovies(`${this._url}/movie/popular`, `&page=${page}`);
	}

	getGenreList() {
		return this.getMovies(`${this._url}/genre/movie/list`);
	}

	getRatedFilms(guestId, page = 1) {
		return this.getMovies(`${this._url}/guest_session/${guestId}/rated/movies`, `&page=${page}&sort_by=created_at.asc`);
	}

	searchMovies(query, page = 1) {
		return this.getMovies(`${this._url}/search/movie`, `&query=${query}&page=${page}`);
	}
}

export default movieDB;
